import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { LanguageNameSpaces, BotType } from "@shared/types";
import {
  Error,
  SummaryData,
  ToggleField,
} from "@shared/features/bots/BotForm/common/types";
import { OrderTypes } from "@shared/features/trades/common/types";
import {
  INVALID_PRICES_ERROR_MESSAGE,
  TV_BOT_ORDERS_SORTER_HEIGHT,
  ANALYTICS_FIELD_NAMES,
} from "@shared/features/bots/BotForm/common/constants";
import { useContext } from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

const useTakeProfitsSummary = (): SummaryData => {
  const { botType, isFetching, errors, parsedTakeProfits, checkedFields } =
    useContext(BotFormContext)!;
  const isDcaBot = botType === BotType.ASAP;
  const isGridBot = botType === BotType.GRID;
  const isTradingViewSignalsBot = botType === BotType.TRADING_VIEW_SIGNALS;
  const isTradingViewBot = botType === BotType.TRADING_VIEW;

  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);

  const title = t(ANALYTICS_FIELD_NAMES[OrderTypes.TAKE_PROFIT]);

  const getErrorMessage = () => {
    if (errors.includes(Error.TAKE_PROFIT_PRICES)) {
      return INVALID_PRICES_ERROR_MESSAGE;
    }
  };

  const priceColumnName =
    isTradingViewBot || isTradingViewSignalsBot
      ? [
          t("ordersSummary.columns.distance_from"),
          t("ordersSummary.columns.first_entry_trigger"),
        ]
      : undefined;

  return {
    key: "takeProfits",
    title,
    orders: parsedTakeProfits,
    isFetching,
    showPrice: isDcaBot || isGridBot,
    amountColumnName: "Ratio",
    priceColumnName,
    orderType: OrderTypes.TAKE_PROFIT,
    botType: botType,
    errorMessage: getErrorMessage(),
    shouldDisplay: checkedFields.has(ToggleField.TAKE_PROFITS),
    showAmount: false,
    hideAmountColumn: isGridBot,
    sorterHeight:
      isTradingViewBot || isTradingViewSignalsBot
        ? TV_BOT_ORDERS_SORTER_HEIGHT
        : undefined,
  };
};

export default useTakeProfitsSummary;
